import { getUserLocale } from "get-user-locale";
import { IETFDictionary, countryPhonesDictionary } from "../localization/i18n";

//de-DE к de
function getFirstPartOfTag(tag) {
  return tag.split("-")[0];
}

const getUserLanguage = () => {
  const langTag = getFirstPartOfTag(getUserLocale());
  const supported = countryPhonesDictionary[langTag] ? langTag : "ru";
  return [supported, IETFDictionary[supported]];
};

export default getUserLanguage;
